import { Controller } from "@hotwired/stimulus"
import Cropper from "cropperjs"

export default class extends Controller {
  static targets = ["input", "modal", "cropImage", "preview"]
  static values = { aspectRatio: { type: Number, default: 4 / 3 } }

  connect() {
    this.files = []
    this.currentIndex = 0
    this.croppedFiles = []
  }

  disconnect() {
    this.destroyCropper()
  }

  selectFiles(event) {
    this.files = Array.from(event.target.files)
    this.croppedFiles = []
    this.previewUrls = []
    this.currentIndex = 0
    if (this.files.length > 0) this.showCropper()
  }

  showCropper() {
    const file = this.files[this.currentIndex]
    const reader = new FileReader()
    reader.onload = (e) => {
      this.cropImageTarget.src = e.target.result
      this.modalTarget.classList.remove("hidden")
      this.destroyCropper()
      this.cropper = new Cropper(this.cropImageTarget, {
        aspectRatio: this.aspectRatioValue,
        viewMode: 1,
        autoCropArea: 1,
        responsive: true,
        background: false
      })
    }
    reader.readAsDataURL(file)
  }

  crop() {
    const canvas = this.cropper.getCroppedCanvas({
      maxWidth: 1600,
      maxHeight: 1200,
      imageSmoothingQuality: "high"
    })

    const dataUrl = canvas.toDataURL("image/jpeg", 0.92)
    if (!this.previewUrls) this.previewUrls = []
    this.previewUrls.push(dataUrl)

    canvas.toBlob((blob) => {
      const originalName = this.files[this.currentIndex].name.replace(/\.[^.]+$/, ".jpg")
      const file = new File([blob], originalName, { type: "image/jpeg" })
      this.croppedFiles.push(file)
      this.currentIndex++

      if (this.currentIndex < this.files.length) {
        this.showCropper()
      } else {
        this.finalize()
      }
    }, "image/jpeg", 0.92)
  }

  skip() {
    const file = this.files[this.currentIndex]
    this.croppedFiles.push(file)
    this.previewUrls.push(URL.createObjectURL(file))
    this.currentIndex++

    if (this.currentIndex < this.files.length) {
      this.showCropper()
    } else {
      this.finalize()
    }
  }

  cancel() {
    this.modalTarget.classList.add("hidden")
    this.destroyCropper()
    this.inputTarget.value = ""
  }

  finalize() {
    this.modalTarget.classList.add("hidden")
    this.destroyCropper()

    const dataTransfer = new DataTransfer()
    this.croppedFiles.forEach(f => dataTransfer.items.add(f))
    this.inputTarget.files = dataTransfer.files

    if (this.hasPreviewTarget && this.previewUrls) {
      this.previewTarget.innerHTML = ""
      this.previewUrls.forEach(url => {
        const img = document.createElement("img")
        img.src = url
        img.className = "w-48 h-32 object-cover rounded-lg border border-sand"
        this.previewTarget.appendChild(img)
      })
    }
  }

  destroyCropper() {
    if (this.cropper) {
      this.cropper.destroy()
      this.cropper = null
    }
  }
}
